import { Injectable, inject } from '@angular/core';
import { HttpRequestService } from '../http-request/http-request.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ImportExportStatusCodes } from '../../constants/error-status-enum';
import { ToastrHelperService } from '../common/toast-helper.service';

@Injectable({
  providedIn: 'root'
})
export class ImportExportService {
  private httpRequestService = inject(HttpRequestService);
  private toastrHelperService = inject(ToastrHelperService);

  downloadExcelFile(API: string, fileName: string, dialogRef?: { close: () => void }) {
    this.httpRequestService.get(API).subscribe({
      next: (response: { fileContent: string }) => {
        if (response) {
          this.exportToExcel(response, fileName);
          dialogRef?.close();
        }
      },
      error: (error: HttpErrorResponse) => this.toastrHelperService.showErrorMessage(error.message)
    });
  }

  exportToExcel(response: { fileContent: string }, fileName: string) {
    const binaryString = window.atob(response.fileContent);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    const blob = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.download = `${fileName}.xlsx`;
    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 0);
  }

  importExportCustomMessage(statuscode: number, errormessage: string): void {
    switch (statuscode) {
      case ImportExportStatusCodes.AllAdded:
        this.toastrHelperService.showSuccessMessage(errormessage);
        break;
      case ImportExportStatusCodes.PartiallyAdded:
        this.toastrHelperService.showErrorMessage(errormessage);
        break;
      default:
        this.toastrHelperService.showErrorMessage(errormessage);
        break;
    }
  }
}
